import unitNTOCard from '../src/assets/img/PIN-NTS/PIN-CARD-NTO.png'
import unitGeneralCard from '../src/assets/img/PIN-NTS/PIN-GENERAL-CARD.png'

// Map
export const MAIN_MAP = "HP";
export const MAIN_ID = "ED-HP";
export const ZAPT_API_KEY = "28382389-ce59-4723-9df6-f66a9b097abc";
export const PRODUCTION_UNIT_CATEGORY = "5905325415202816";
export const STAGES_CATEGORY = "5762869289811968";
export const STATES_CATEGORY = "4645983062851584";

// API

export const AUTH_KEY = "%EDIGITAL";
export const AUTH_PASS = "3nteRD|g!T@l";
export const API_URL = process.env.REACT_APP_API_URL;
export const MY_PARDINI_URL = process.env.REACT_APP_MY_PARDINI_URL;
export const FETCH_INTERVAL = 60000;

// Pardini Info

export const FOLDER_HOMOL = "/enterprisedigital";

export const PRODUCTION_UNIT_NAMES = {
    HP: "Hermes Pardini",
    NTHNO: "Hermes Pardini - NTH - Belém - PA",
    NTHCE: "Hermes Pardini - NTH - Belém - CE",
    NTOGO: "Hermes Pardini - NTH - Goiânia - GO",
    SOLUCAO: "Hermes Pardini - Solução - Itajaí - CE",
    NTOSP: "Hermes Pardini - NTA - São Paulo - SP",
    NTARJ: "Hermes Pardini - NTA - Rio de Janeiro - RJ",
    NTADLE: "Hermes Pardini - NTA-DLE - Rio de Janeiro - RJ",
    NTBH: "Hermes Pardini - NT - Belo Horizonte - MG",
    NTO: "Hermes Pardini - NTO - Vespasiano - MG",
}

export const PRODUCTION_UNIT_FEDERATIONS = {
    "NTH-PA": "PA",
    "NTH-CE": "CE",
    "NTA-GO": "GO",
    "NTA-Solução": 'CE',
    "NTA-SP": "SP",
    "NTA-RJ": "RJ",
    "NTA-DLE": "RJ",
    "NTA-BH": "MG",
    "NTO": "MG",
}

export const PRODUCTION_UNIT_ALIAS = {
    HP: "Hermes Pardini",
    NTHNO: "NTH-PA",
    NTHCE: "NTH-CE",
    NTOGO: "NTA-GO",
    SOLUCAO: "NTA-Solução",
    NTOSP: "NTA-SP",
    NTARJ: "NTA-RJ",
    NTADLE: "NTA-DLE",
    NTBH: "NTA-BH",
    NTO: "NTO",
}

export const PRODUCTION_UNIT_HAS_MAP = {
    HP: true,
    NTHNO: false,
    NTHCE: false,
    NTOGO: false,
    SOLUCAO: false,
    NTOSP: false,
    NTARJ: false,
    NTADLE: false,
    NTBH: false,
    NTO: true,
}

// Layout
export const STAGE_ICONS = {
  "CADASTRADO": "cadastrado",
  "EM ANÁLISE TÉCNICA": "conferencia",
  "EM PROCESSAMENTO": "processando",
  "RECEBIDO": "recebido",
  "RECOLHIDO": "recolhido",
  "RESULTADO LIBERADO": "concluido",
  "RECOLETA": 'recoleta',
  "PENDÊNCIA TÉCNICA": "pendente",
};

export const STAGE_COLORS = {
    "Cadastrado": "pin-cadastrado",
    "Em Análise Técnica": "pin-conferencia",
    "Em Processamento": "pin-processando",
    "Recebido": "pin-recebido",
    "Recolhido": "pin-recolhido",
    "Resultado Liberado": "pin-concluido",
    "Pendência Técnica": "pin-pendente",
    "Recoleta": "pin-recoleta",
}

export const STAGE_COLORS_UPPERCASE = {
    "CADASTRADO": "pin-cadastrado",
    "EM ANÁLISE TÉCNICA": "pin-conferencia",
    "EM PROCESSAMENTO": "pin-processando",
    "RECEBIDO": "pin-recebido",
    "RECOLHIDO": "pin-recolhido",
    "RESULTADO LIBERADO": "pin-concluido",
    "PENDÊNCIA TÉCNICA": "pin-pendente",
    "RECOLETA": "pin-recoleta"
}

export const STAGE_STATUS = {
    "Cadastro": "status-cadastrado",
    "Em Análise Técnica": "pin-conferencia",
    "Em Processamento": "pin-processando",
    "Recebido": "pin-recebido",
    "Recebido NTO": "pin-recolhido",
    "Resultado Liberado": "pin-concluido",
    "Pendência Técnica": "pin-pendente",
    "Recoleta": "pin-recoleta"
}

export const STAGE_SHORT = {
    "CADASTRADO": "Cadastrado",
    "EM ANÁLISE TÉCNICA": "Análise Técnica",
    "EM PROCESSAMENTO": "Em Processamento",
    "RECEBIDO": "Recebido",
    "RECOLHIDO": "Recolhido",
    "RESULTADO LIBERADO": "Liberado",
    "PENDÊNCIA TÉCNICA": "Pendente",
    "RECOLETA": "Recoleta"
}

export const STAGE_COLOR_CODE = {
    "CADASTRO": "#4DA9FF",
    "CADASTRADO": "#4DA9FF",
    "EM ANÁLISE TÉCNICA": "#72CF46",
    "EM PROCESSAMENTO": "#ff4cff",
    "RECEBIDO": "#5A85FF",
    "RECOLHIDO": "#0030B6",
    "RESULTADO LIBERADO": "#13CACA",
    "PENDÊNCIA TÉCNICA": "#E58148",
    "RECOLETA": "#27D2F8",
    "Default": '#545772'
}

export const UNIT_IMG_CARD = {
    'NTO': unitNTOCard,
    "NTHNO": unitGeneralCard,
    "NTHCE": unitGeneralCard,
    "NTOGO": unitGeneralCard,
    "SOLUCAO": unitGeneralCard,
    "NTOSP": unitGeneralCard,
    "NTARJ": unitGeneralCard,
    "NTADLE": unitGeneralCard,
    "NTBH": unitGeneralCard,
}
